import React from 'react'
import { Toggle } from '@fs/zion-ui'
import { trackEvent } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'

const FullTextActions = ({ showKeywords, setShowKeywords }) => {
  const [t] = useTranslation()

  return (
    <Toggle
      checked={showKeywords}
      label={t('full-text.show-keywords', 'Show Keywords')}
      onChange={() => {
        const newState = !showKeywords
        setShowKeywords(newState)
        trackEvent({
          event_name: 'click_action',
          link_name: newState ? 'full-text-keywords-show' : 'full-text-keywords-hide',
        })
      }}
    />
  )
}

export default FullTextActions
